import api from './api';

const PREFIX = '/songs/certificates/admin';

export const listCertificatesAdmin = (params) =>
  api.get(`${PREFIX}`, { params });

export const getCertificateAdminDetail = (id) =>
  api.get(`${PREFIX}/${id}`);

export const deleteCertificatesAdminByTask = (taskId) =>
  api.delete(`${PREFIX}/by-task/${encodeURIComponent(taskId)}`);

export const createCertificateAdmin = (payload) =>
  api.post(`${PREFIX}`, payload);

export const getCertificatePurchaseStatus = (taskId) =>
  api.post('/songs/certificate/purchase-status', { task_id: taskId });

export const markCertificatePurchased = (payload) =>
  api.post('/songs/certificate/mark-purchased', payload);

